import {drawer} from '@cypro/ui/components'
import {Patient, PatientGfr} from '@cypro/engine/schema'
import {Suspense} from 'react'
import {GfrDrawer} from './gfr-drawer'

export function getGfrDrawerId(gfrId: string) {
  return `gfr-drawer-${gfrId}`
}

export function openGfrDrawer(gfr: PatientGfr, patient: Patient) {
  const id = getGfrDrawerId(gfr.id)

  try {
    drawer.remove(id)
  } catch {}

  drawer.open(id, {
    id,
    children: (
      <Suspense fallback={null}>
        <GfrDrawer gfr={gfr} patient={patient} />
      </Suspense>
    ),
  })
}
